import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { useUserContext } from '@/context'

import { createAPIOptions, createAPIQueryFunction, useAPIOptions } from './'
import { useAPIDest } from './useAPI.types'
import { gambitDefaultAPIOptions } from './useAPI.util'

export function useAPIMutation<TVariables = void, TData = unknown, TError = unknown>(
  dest: useAPIDest,
  options?: useAPIOptions<UseMutationOptions<AxiosResponse<TData>, AxiosError<TError>, TVariables>>,
) {
  const { user } = useUserContext()

  const gambitOptions = {
    ...options,
    headers: { ...options?.headers, ...gambitDefaultAPIOptions?.headers },
  }

  function handleResponse(res: AxiosResponse<TData>) {
    return res // * useAPIMutation onSuccess handler uses the AxiosResponse object as is. useAPI by default sends res.data
  }

  const { headers, data, params, nonKeyParams, ...queryOptions } = createAPIOptions<
    UseMutationOptions<AxiosResponse<TData>, AxiosError<TError>, TVariables>
  >(gambitOptions, user)
  const queryFnOptions = { headers, data, params }
  const queryFn = createAPIQueryFunction(dest, queryFnOptions, handleResponse)

  return useMutation<AxiosResponse<TData>, AxiosError<TError>, TVariables>({ mutationFn: queryFn, ...queryOptions })
}
